import * as React from "react";
import { JSX } from "react/jsx-runtime";

const SVGComponent = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    width={25}
    height={25}
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x={-0.5}
      y={0.5}
      width={24}
      height={24}
      rx={12}
      transform="matrix(-1 0 0 1 24 0)"
      stroke="#1F2A37"
    />
    <path
      d="M16.6666 8.75L12.4999 12.9167L8.75 16.6666"
      stroke="#1F2A37"
      strokeWidth={1.2}
      strokeLinecap="round"
    />
    <path
      d="M8.75044 8.75L12.9171 12.9167L16.667 16.6666"
      stroke="#1F2A37"
      strokeWidth={1.2}
      strokeLinecap="round"
    />
  </svg>
);

export default SVGComponent;
